module.exports = __webpack_public_path__ + "img/BilibiliQRcode.d13157ea.png";